import { Box, Button, Stack, Typography } from '@mui/material';
import { useIntl, FormattedMessage } from 'react-intl';

import CopyIcon from '../../../assets/svg/meeting/copyIcon.svg';
import { useToastNotificationContext } from '../../../hooks/global/alert/useToastNotification';

function MeetingInfo() {
  const intl = useIntl();
  const { createToastNotification } = useToastNotificationContext();
  const currentURL = window.location.toString();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '125%',
          marginBottom: '24px',
        }}
      >
        <FormattedMessage defaultMessage='Meeting information' />
      </Typography>
      <Stack gap={1}>
        <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>
          <Stack justifyContent='center'>
            <FormattedMessage defaultMessage='Meet link' />
          </Stack>
          <Box>
            <Button
              sx={{
                color: (theme) => theme.palette.blue.main,
              }}
              variant='text'
              startIcon={
                <img src={CopyIcon} alt='Copy' style={{ height: 24 }} />
              }
              onClick={() => {
                createToastNotification(
                  intl.formatMessage({ defaultMessage: 'Copied to clipboard' }),
                  'success',
                );
                navigator.clipboard.writeText(window.location.toString());
              }}
            >
              <FormattedMessage defaultMessage='Copy meet link' />
            </Button>
          </Box>
        </Stack>
        <Stack direction='row' justifyContent='start'>
          <Box>{currentURL}</Box>
        </Stack>
      </Stack>
    </Box>
  );
}

export default MeetingInfo;
